const PRODUCT_FAMILY_IMAGE_KEY_INVALID_SYMBOLS = /-/g

/**
 * Creates the lookup key used for product family images by removing unsupported characters.
 *
 * @param {string|undefined} productFamily - Product family name from product data.
 * @returns {string|undefined} Product family image lookup key, or undefined when no family is provided.
 */
export const getProductFamilyImageKey = (productFamily) =>
    productFamily?.replace(PRODUCT_FAMILY_IMAGE_KEY_INVALID_SYMBOLS, '')

/**
 * Finds the configured image for a product family.
 *
 * @param {Object<string, string>|undefined} productFamilyImage - Map of normalized family keys to image values.
 * @param {string|undefined} productFamily - Product family name from product data.
 * @returns {string|undefined} Image value for the product family, or undefined when no match exists.
 */
export const getProductFamilyImage = (productFamilyImage, productFamily) =>
    productFamilyImage?.[getProductFamilyImageKey(productFamily)]
